export enum QaroniViewsEnum {
  LIST = 'view_list',
  GRID = 'grid_view',
}

export type QaroniViewsEnumType = QaroniViewsEnum.LIST | QaroniViewsEnum.GRID;

export const QaroniViewsArray = [QaroniViewsEnum.LIST, QaroniViewsEnum.GRID];
